import React, { useState, useEffect } from 'react';
import api from '../services/api';

const PERMANENT_DOCS = [
  'NID', 'Pass Port', 'Driving License', 'TIN', 'BIN', 'Marriage Certificate', 'Birth Certificate', 'Land Deed', 'Other'
];
const PERIODICAL_DOCS = [
 'Tax Certificate', 'Tax Return Acknowledgment', 'Tax Return', 'Salary Certificate', 'Bank Statement', 'DPS Statement', 'Shanchoypatra Statement', 'Share Certificate', 'Other'
];

const DocumentUpload = ({ category = 'any', types = null, onUpload, targetUserId = null }) => {
  const [docType, setDocType] = useState('');
  const [docYear, setDocYear] = useState('');
  const [remarks, setRemarks] = useState('');
  const [file, setFile] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (types && Array.isArray(types)) {
      setOptions(types);
    } else if (category === 'permanent') {
      setOptions(PERMANENT_DOCS);
    } else if (category === 'periodical') {
      setOptions(PERIODICAL_DOCS);
    } else {
      setOptions([...PERMANENT_DOCS, ...PERIODICAL_DOCS]);
    }
    setDocType('');
    setDocYear('');
    setRemarks('');
    setFile(null);
  }, [category, types]);

  // Show year only when category is periodical (regardless of type)
  const showYear = category === 'periodical';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!docType) return alert('Please select document type');
    if (!file) return alert('Please choose a file to upload');

    // If category is periodical, require year (or allow empty but send it)
    if (category === 'periodical' && !docYear) {
      if (!window.confirm('No year provided. Continue without year?')) return;
    }

    try {
      const fd = new FormData();
      fd.append('docType', docType);
      fd.append('category', category); // explicit category
      if (showYear && docYear) fd.append('docYear', docYear);
      fd.append('remarks', remarks || '');
      // include optional target user id (for consultant/admin uploading on behalf of a client)
      if (targetUserId) fd.append('userId', String(targetUserId));
      fd.append('file', file);

      await api.post('/documents/upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      onUpload && onUpload();
      // reset form
      setDocType('');
      setDocYear('');
      setRemarks('');
      setFile(null);
    } catch (err) {
      console.error('Upload failed', err);
      alert(err?.response?.data?.message || 'Upload failed');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        <select value={docType} onChange={e => setDocType(e.target.value)} style={{ flex: 1, padding: 8, borderRadius: 6 }}>
          <option value="">Select document type</option>
          {options.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>

        {showYear && (
          <input
            placeholder="Year"
            value={docYear}
            onChange={e => setDocYear(e.target.value)}
            style={{ width: 110, padding: 8, borderRadius: 6 }}
          />
        )}
      </div>

      <input
        placeholder="Remarks (optional)"
        value={remarks}
        onChange={e => setRemarks(e.target.value)}
        style={{ padding: 8, borderRadius: 6 }}
      />

      <input type="file" onChange={e => setFile(e.target.files?.[0] || null)} />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button type="submit" style={{ background: '#1976d2', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: 6 }}>
          Upload
        </button>
      </div>
    </form>
  );
};

export default DocumentUpload;